import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi, type InternalRequest, type PostRequisitesResponse, type StoreBaseReturn } from '@shared/api';

interface UseInternalStore {
  data?: PostRequisitesResponse | null;
  loading: boolean;
  error: string | null;
  createInternal: (request: InternalRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<PostRequisitesResponse | null>>;
  clear: () => void;
}

export const useInternalStore = create<UseInternalStore>((set) => ({
  data: undefined,
  loading: false,
  error: null,

  createInternal: async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await PaymentsApi.internal(request, signal);
      set({ data: result || null, loading: false });
      return { loading: false, data: result || null };
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      return { loading: false, data: null, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ data: undefined, loading: false, error: null }),
}));
